require('./filter');
require('./forEach');
require('./map');



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx/src/polyfills/index.js
 ** module id = 1
 ** module chunks = 0
 **/